var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.98 32h3.17C42.868 32 50 24.8 50 16S42.867 0 34.15 0H0l3.66 6.4h30.49c5.23 0 9.51 4.32 9.51 9.6 0 5.28-4.28 9.6-9.51 9.6h-3.17V32zM7.32 12.8l3.66 6.4h7.321V32h6.34V19.2h12.68v-6.4h-30z",
    fill: "#fff"
  })));
}

export default SvgMobileLogoWhite;